module.exports = __webpack_public_path__ + "45d98484b76e2fcded5e83a6ed3fc746.pdf";